@if (model) {
    <div>
        @if (!isLoading) {
            <div>
                <risk-linkable
                    #linkable
                    data-uiid="thirdpartyrisk-risklinkable"
                    typename="Risks"
                    displayValueProp="name"
                    [linked]="linked"
                    [unlinked]="unlinked"
                    [hideActions]="true"
                    [orderByValueProperty]="true"
                    (linkedChange)="linkedChanged($event)"
                    [disabled]="disabled"
                >
                </risk-linkable>
            </div>
        } @else {
            <div>
                <div class="fancy-loader"></div>
            </div>
        }
    </div>
}
